import React from 'react';
// Interfaces
import { Input as InputInterface } from '../../../interfaces/form';
// Utils
import Translate from '../../../utils/translate';

function Select({
  data,
  errors,
  register,
  extraClasses,
}: {
  data: InputInterface;
  errors: any;
  register: any;
  extraClasses: string;
}) {
  const { id, placeholder, name, selectValues, required, focused } = data;

  return (
    <div
      className={`cl-form-field ${errors[name]?.message ? 'cl-form-field--invalid' : ''} ${
        extraClasses && extraClasses
      }`}
    >
      <select
        {...register(name, {
          required: {
            value: required,
            message: Translate('Field is required'),
          },
          minLength: {
            value: 1,
            message: Translate('Select an option'),
          },
        })}
        className='cursor-pointer cl-form-field__input peer'
        id={`id-${id}`}
        required={required}
        defaultValue=''
        autoFocus={focused}
      >
        {selectValues?.map((value: string, index: number) => {
          return (
            <React.Fragment key={index}>
              {index === 0 ? (
                <option value='' disabled selected></option>
              ) : (
                <option value={value.replace(' Users' || ' users', '')}>{value}</option>
              )}
            </React.Fragment>
          );
        })}
      </select>

      <label htmlFor={`id-${id}`} className='text-sm cl-form-field__label'>
        {placeholder}
      </label>

      <svg
        width='16'
        height='16'
        viewBox='0 0 16 16'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
        className='cl-form-field__trailing-icon'
      >
        <path
          d='M12 6L8.18844 9.8112C8.16371 9.83597 8.13434 9.85562 8.102 9.86903C8.06967 9.88243 8.035 9.88933 8 9.88933C7.965 9.88933 7.93033 9.88243 7.898 9.86903C7.86566 9.85562 7.83629 9.83597 7.81156 9.8112L4 6'
          stroke='#6D6562'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
      </svg>

      {errors[name]?.message && (
        <small className='cl-form-field__helper'>
          <span>* {errors[name]?.message}</span>
        </small>
      )}
    </div>
  );
}

export default Select;
